import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PasswordRecoveryComponent } from './password-recovery.component';

const PasswordRecoveryRoutes: Routes = [
    {
        path: 'password-recovery',
        component: PasswordRecoveryComponent,
        data: { token: 'token' }
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(PasswordRecoveryRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class PasswordRecoveryRoutingModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/password-recovery/password-recovery.routing.module.ts